import BasicContentMediaGridItem from './BasicContentMediaGridItem';

export { type BasicContentMediaGridItemProps } from './BasicContentMediaGridItem';
export default BasicContentMediaGridItem;
